export const SESSION_STORAGE_EXTERNAL_SERVICE_CALLBACK_DESTINATION_URL =
  "SESSION_STORAGE_EXTERNAL_SERVICE_CALLBACK_DESTINATION_URL";

export const host = window.location.origin;

export const persistCallbackDestination = (path: string) => {
  const link = `${host}${window.location.pathname}#/${path}`;
  sessionStorage.setItem(SESSION_STORAGE_EXTERNAL_SERVICE_CALLBACK_DESTINATION_URL, link);
};
